// src/components/FloatWA.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // Import ikon WhatsApp dari react-icons
import './FloatWA.css';

const FlyButton = () => {
    const handleClick = () => {
        const message = `Halo men`;
        const whatsappUrl = `https://wa.me/6285179583850?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <button className="float-button" onClick={handleClick}>
            <FaWhatsapp size={30} color="white" />
        </button>
    );
};

export default FlyButton;
